import { render, staticRenderFns } from "./LivingOptionsSubsections.vue?vue&type=template&id=53da3cf8&"
import script from "./LivingOptionsSubsections.vue?vue&type=script&lang=js&"
export * from "./LivingOptionsSubsections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports